<template>
  <div class="ui column grid centered">
    <div class="seven wide column">
      <t-form-new-campaign v-if="newCampaign" />
      <t-form-edit-campaign v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    components: {
    TFormNewCampaign: () => import('./new.vue'),
    TFormEditCampaign: () => import('./edit.vue')
  },
  data () {
    return {
      newCampaign: true
    }
  },

  computed: {
    ...mapState({
      loading: ({ campaign }) => campaign.loading
    })
  },

  mounted () {
    if (this.$route.params.id) {
      const { id } = this.$route.params

      if (id !== 'new') {
        this.newCampaign = false
      }
    }
  }
}
</script>

<style lang="scss">

.tui.ui.form {
  margin-bottom: 60px;

  .form-field .ui.selection.dropdown.dropdown-frequency,
  .tui.form-field .ui.selection.dropdown.dropdown-frequency{
    width: 80px;
    height: 40px;
    min-width: 110px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 11px 10px;
  }

  .form-field input:not([type="file"]).name-campaign {
    padding-right: 70px;
  }
}
</style>
